import { ILayerComposer, ILayerViewModel, ILayout } from '../models/interfaces';
import { LayerViewModel } from '../view-models/layer-viewmodel';

class ChangeDetection<T> {
    // data members

    private _isFirstUse = true;
    private _value: T;

    // constructor

    constructor(defaultValue: T) {
        this._value = defaultValue;
    }

    // public functions

    isChanged(value: T): boolean {
        if (this._isFirstUse) {
            this._value = value;
            this._isFirstUse = false;
            return true;
        } else if (this._value != value) {
            this._value = value;
            return true;
        }

        return false;
    }
}

export class ChangeDetectionComposer<T> implements ILayerComposer {
    // data members

    protected layout: ILayout;
    protected changeDetection: ChangeDetection<T>;

    // constructor

    constructor(layout: ILayout, defaultValue: T) {
        this.layout = layout;
        this.changeDetection = new ChangeDetection<T>(defaultValue);
    }

    // public functions

    update(layers: Array<LayerViewModel>, force = false) {
        if (!force && !this.isChanged()) return;

        this.onUpdateAll(layers);
    }

    updateSingle(layer: LayerViewModel, force = false) {
        if (!force && !this.isChanged()) return;

        this.onUpdate(layer);
    }

    public isChanged() {
        return false;
    }

    // protected functions

    protected onUpdateAll(layers: Array<ILayerViewModel>) {
        layers.forEach((layer) => this.onUpdate(layer));
    }

    protected onUpdate(_: ILayerViewModel) {}
}
